export const PLANS = {
  free:  { id: 'free',  label: 'Gratuit', maxClients: 3,   ai: false, exportPdf: false, multiCoach: false },
  pro:   { id: 'pro',   label: 'Pro',     maxClients: 15,  ai: true,  exportPdf: true,  multiCoach: false },
  ultra: { id: 'ultra', label: 'Ultra',  maxClients: Infinity, ai: true, exportPdf: true, multiCoach: true },
};

export const PLAN_FEATURES = {
  ai_generation:         ['pro', 'ultra'],
  ai_memory:             ['pro', 'ultra'],
  ai_preferences:        ['pro', 'ultra'],
  ai_moderation:         ['pro', 'ultra'],
  ai_tags_notes:         ['pro', 'ultra'],
  ai_cross_client:       ['pro', 'ultra'],
  export_pdf:            ['pro', 'ultra'],
  multi_coach_dashboard: ['ultra'],
};

export const TRIAL_DURATION_DAYS = 14;
